// AUTO-GENERATED by scripts/fetch-cms-content.mjs (DIT-334 → CMS).
// Gitignored — do NOT edit or commit. Empty `{}` means "use baked content".
/* eslint-disable */
export const CMS_TESTIMONIALS: Record<string, Array<{
  slug: string; author: string; photo: string; role: string; quote: string;
}>> = {};
